import { Navigate } from 'react-router-dom';
import { useSelector } from 'react-redux';
import { RootState } from '../redux/store';

interface ProtectedRouteProps {
  children: React.ReactNode;
  redirectTo: string;
  requireAuth: boolean;
}

const ProtectedRoute = ({ children, redirectTo, requireAuth }: ProtectedRouteProps) => {
  const isAuthenticated = useSelector((state: RootState) => state?.user.isAuthenticated)

  if (requireAuth && !isAuthenticated) {
    return <Navigate to={redirectTo} replace state={{ from: location }} />;
  }

  if (!requireAuth && isAuthenticated) {
    return <Navigate to={redirectTo} replace />;
  }

  return <>{children}</>;
};

export default ProtectedRoute;
